import { useNavigate } from "react-router-dom"

import { AccountSettingsPassword } from "modals/AccountSettingsPassword"

import { AccountRoutePanel } from "./shared"

export const ContractorPasswordPage = () => {
  const navigate = useNavigate()

  return (
    <AccountRoutePanel>
      <AccountSettingsPassword onCancel={() => navigate(-1)} />
    </AccountRoutePanel>
  )
}
